import { Card } from "react-bootstrap";
import { ContractorWasteKindOffcanvas } from "../CreateContractor/ContractorWasteKindOffcanvas";
import { BadgeDomain } from "../../../../_components/Abstractions/BadgeDomain";

export const ContractorWasteKindDetails = ({ contractorId, address }) => {
  if(address.usedWastes.length === 0) {
    return;
  }
  return (
    <>
      <Card border="light">
        <Card.Header as="h5">Gatunki towarów <ContractorWasteKindOffcanvas contractorId={contractorId} addressId={address.id} wastes={address.usedWastes}/>
        </Card.Header>
        <Card.Body className="d-flex gap-2 flex-wrap">
          {address.usedWastes.map(x =>
            x.wasteKinds.length > 0 ?
              x.wasteKinds.map(k => <BadgeDomain
                key={k.wasteKindId ?? x.waste.wasteId}
                bg="fiolet"
                size="smaller">
                {x.waste.wasteCode} - {x.waste.internalName} ({k.name})
              </BadgeDomain>) :
              <BadgeDomain
                key={x.waste.wasteId}
                bg="fiolet"
                size="smaller">
                {x.waste.wasteCode} - {x.waste.internalName} (-)
              </BadgeDomain>)
          }
        </Card.Body>
      </Card>
    </>
  );
};